export default "__VITE_ASSET__oQInr5tj__"